<template>
<pop-up-layout 
  :title="$t('promociones.doc')"
  :description="$t('promociones.textoDoc')"
  :aceptar="$t('general.misc.guardarCambios')"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  :disabled="!cambiado"
  @volver="$parent.hide()"
  @aceptar="guardar()"
>
  <v-layout align-center wrap>
    <v-flex xs12 sm6>
      <o-base-justify-text>{{$t('promociones.docPreguntaModulos')}}</o-base-justify-text>
    </v-flex>
    <v-layout column :class="$vuetify.breakpoint.smAndUp ? 'pl-3' : ''">
      <v-btn
        @click.stop
        :href="$plantillaKycFisico()" target="_blank"
        color="primary" :style="$vuetify.breakpoint.smAndUp ? 'width: 320px' : ''"
      >
        {{$t('promociones.plantillaCF')}}
      </v-btn>
      <v-btn
        @click.stop
        :href="$plantillaKycJuridico()" target="_blank"
        color="primary" :style="$vuetify.breakpoint.smAndUp ? 'width: 320px' : ''"
      >
       {{$t('promociones.plantillaCJ')}}
      </v-btn>
    </v-layout>
  </v-layout>
  <o-base-justify-text>{{$t('promociones.datosDoc')}}</o-base-justify-text>
  <v-form v-model="valid" ref="form">
    <v-slide-y-transition group tag="div">
      <v-layout :column="$vuetify.breakpoint.smAndDown" mb-3 mt-3
        v-for="(documento, i) in documentos"
        :key="'documento'+ documento.id_temporal"
        align-center
      >
        <v-card row style="width: 100%">
          <v-card-text class="pt-1">
            <o-medium-title-erase @borrar="mostrarAvisoBorrarDocumento(i)" >
              <template #icon>
                <v-icon 
                  color="primary" 
                  style="margin-top:13px;font-weight:bold"
                  class="custom-icon icon-file pr-1" 
                /> 
              </template>
              {{$t('promociones.documento', {numero: (i+1)})}}
            </o-medium-title-erase>
            <v-layout 
              wrap pa-2 justify-space-between
              :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
            >
              <v-flex xs12 md5 px-2>
                <label class="text-xs-center mb-2" style="color: grey;font-weight: 300;font-size: smaller;">
                  {{$t('promociones.addDoc')}}
                </label>
                <FileUploader
                  :subPopUp="true"
                  :name="'documento['+ i +']'"
                  style="height:144px; width: 235px"
                  :maxNum="1"
                  v-model="documentos[i].documento"
                  :deletable="true"
                />
                <v-text-field
                  :name="'nombre['+ i +']'"
                  :label="$t('general.misc.nombre')"
                  :rules="[rules.obligatorio, rules.max(90)]"
                  v-model="documento.nombre"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-layout column>
                  <label class="grey--text mb-2">
                     {{$t('promociones.seleccioneModulos')}}
                  </label>
                  <v-checkbox
                    class="ml-2 mt-0"
                    v-for="(modulo, j) in tiposModulos"
                    :key="documento.id_temporal + '-' + modulo.tipo"
                    :label="modulo.descripcion"
                    v-model="documentos[i].mostrarDocumentacion[j].mostrar"
                    :ripple="false"
                    hide-details
                    color="primary"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-slide-y-transition>
  </v-form>
  <add-arrendatario :disabled="waitingForLoad" @addArrendatario="addDocumento">
    <template #icon>
      <v-icon  
        color="primary" 
        :class="$vuetify.breakpoint.lgAndUp ? 'btnAddArrendatario' : ''"
        class="custom-icon icon-add-page" 
        large
      />
    </template>
    {{$t('promociones.addDocumento')}}
  </add-arrendatario>
  <v-fade-transition>
    <custom-dialog 
      v-if="mostrarBorrarDocumento" 
      v-model="mostrarBorrarDocumento"
      @aceptar="mostrarBorrarDocumento = $event"
    >
      <DocumentoBorrar
        :indice="indiceBorrar + 1"
        :nombre="nombreBorrar"
        @eliminar="borrarDocumento"
      />
    </custom-dialog>
  </v-fade-transition>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import DocumentoBorrar from './DocumentoBorrar'
import uniqid from 'uniqid'
import FileUploader from '@/components/generic/fileUploader/FileUploader'

export default {
  mixins: [rules],
  components: {
    DocumentoBorrar,
    FileUploader
  },
  props: {
    codigoPromocion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: true,
      documentos: [],
      mostrarBorrarDocumento: false,
      valid: true,
      cambiado: false
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromociones(this.codigoPromocion)
      this.documentos = this.promocion.documentos.map(x => {
        return {
          id_temporal: uniqid(),
          nombre: x.documento.nombre.slice(0, x.documento.nombre.length - (x.documento.extension.length + 1)),
          documento: [x.documento],
          mostrarDocumentacion: this.tiposModulos.map(tipoModulo => {
            return {
              tipo: tipoModulo.tipo,
              mostrar: x.tiposModulo.some(y => y.tipo === tipoModulo.tipo)
            }
          })
        }
      })
      if (this.documentos.length < 1) {
        this.addDocumento()
      }
      this.$nextTick(() => {
        this.loading = false
      })
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      promocionId: 'promociones/getById'
    }),
    tiposModulos () {
      return [
        {
          tipo: 'condiciones',
          descripcion: this.$t('promociones.condiciones')
        },
        {
          tipo: 'pago',
          descripcion: this.$t('promociones.pago')
        },
        {
          tipo: 'contrato',
          descripcion: this.$t('promociones.firmaContrato')
        },
        {
          tipo: 'kyc',
          descripcion: this.$t('promociones.fichaDatos')
        },
        {
          tipo: 'documentacion',
          descripcion: this.$t('promociones.fichaDoc')
        }
      ]
    },
    promocion () {
      return this.promocionId(this.codigoPromocion)
    },
    objetoParaApi () {
      return {
        codigoPromocion: this.codigoPromocion,
        documentos: this.documentos.map(x => {
          if (x.documento.length === 0) {
            return null
          }
          let aux = {...x.documento[0]}
          aux.nombre = x.nombre + '.' + aux.extension
          aux.mostrarDocumentacion = x.mostrarDocumentacion.filter(y => y.mostrar).map(z => {
            return z.tipo
          })
          return aux
        })
      }
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromociones: 'promociones/loadPromocionSinBorrar',
      modificar: 'promociones/modificarDocumentos'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    addDocumento () {
      this.documentos.push(this.nuevoDocumento())
    },
    nuevoDocumento () {
      return {
        id_temporal: uniqid(),
        nombre: null,
        documento: [],
        mostrarDocumentacion: this.tiposModulos.map(x => {
          return {
            tipo: x.tipo,
            mostrar: false
          }
        })
      }
    },
    mostrarAvisoBorrarDocumento (i) {
      this.nombreBorrar = this.documentos[i].nombre
      this.indiceBorrar = i
      this.mostrarBorrarDocumento = true
    },
    borrarDocumento () {
      this.mostrarBorrarDocumento = false
      this.documentos.splice(this.indiceBorrar, 1)
      this.indiceBorrar = -1
    },
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      if (this.objetoParaApi.documentos.some(x => x == null)) {
        this.addAlert({texto: this.$t('promociones.avisoArchivo'), color: 'error'})
        return
      }
      if (this.objetoParaApi.documentos.some(doc => doc.mostrarDocumentacion.length <= 0)) {
        this.addAlert({texto: this.$t('promociones.avisoArchivoModulo'), color: 'error'})
        return
      }
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.modificar(this.objetoParaApi)
        this.$emit('cambiado', false)
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('general.misc.cambiosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  watch: {
    documentos: {
      deep: true,
      handler () {
        if (!this.loading) {
          this.cambiado = true
          this.$emit('cambiado', this.cambiado)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.btnAddArrendatario
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);

@media (max-width: 1200px)
    .buttonOtrosCompradores
      margin-top:0 !important

@media (min-width: 1112px)
  .buttonOtrosCompradores
    margin-bottom:0 !important
    position: absolute 
    right: 10px
    top: 1%;

</style>



// WEBPACK FOOTER //
// src/components/promociones/PopUpPromocionesDocumentos.vue